export default __webpack_public_path__ + "1da640fa4c6c4b370f7eaf9230408675.jpg";